import styled from 'styled-components'

export const StyledContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	img {
		max-height: 50px;
		width: auto;
	}
`
